import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { DCService } from "../../../services/index";
import { JGRNService } from "../../../services/jgrn.service";


@Component({
  selector: "addEditsampleToBitConvertGrn",
  templateUrl: "./addEditsampleToBitConvertGrn.html"
})
export class addEditsampleToBitConvertGrn {
  row: any;
  data: any;
  mode = "Add";
  dcdata: any = { dc_id: "", total_mtr: 0 };
  dcdata1: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  loadingIndicator: boolean = false;
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  desData: any = {
    totDes: 0
  };
  barcodeList = [];
  workOrderBarcodeList = [];
  unitList: any;
  rd_season = []
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  dcList = [
    {
      lump_no: "",
      design_no: "",
      color: "",
      hsn: "",
      width: "",
      qty: 0,
      wo_no: "",
      grn_id : 0,
      grn_det_id : 0,
      stock_type : ''
    }
  ];
  woList: any = [];
  noofpcs: number;
  export: boolean = false;
  // box:boolean;
  // shirt:boolean;
  printRes: any;
  printPreview = [];
  isLoadMask: Promise<any>;

  page_id: string =
    Math.random()
      .toString(36)
      .substr(2, 9) + "_";

  isLoading = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;
  dc_id: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
   
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private dcService: DCService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    public jgrn: JGRNService,


  ) {
      this.dcdata.From = 'Sample/Swatch';
      this.dcdata.to = 'Bit';
    this.data = {
      dcdata1: []
    };
  }
  ngOnInit() {
    if (this.mode == "Add") {
      this.dcdata.dc_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getbarcodeListForSample();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#section").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if (nextEl == "barcodegood") {
      $("#" + this.page_id + "barcode-0").focus();
    } else {
      $("#" + this.page_id + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    if (fld == "color") {
      let totdes = 0;
      const designlist = [];
      for (let i = 0; i < this.dcList.length; i++) {
        const design = this.dcList[i].design_no;
        if (design != "") {
          if (designlist.indexOf(design) == -1) {
            designlist.push(design);
            totdes++;
          }
        }
      }
      this.dcdata.total_design = totdes;
    }

    let nxtInd = ind,
      barcode = this.dcList[ind]["lump_no"],
      design = this.dcList[ind]["design_no"],
      color = this.dcList[ind]["color"],
      hsn = this.dcList[ind]["hsn"],
      width = this.dcList[ind]["width"],
      qty = this.dcList[ind]["qty"];

    const nxtRow = $("#row-" + ind).next("tr");
    if (fld == "barcode" && nxtRow.length == 0) {
      if (this.dcList[ind].qty == 0) {
        swal({
          title:
            "Please Enter the Valid Mtr for design " +
            this.dcList[ind].design_no,
          timer: 1000,
          showConfirmButton: false
        });
        return false;
      }

      const len = this.dcList.length;
      const lump_no = this.dcList[len - 1]["lump_no"];
      const qty = this.dcList[len - 1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "design" + "-" + nxtInd).focus();

      if (lump_no != "" && nxtInd == len) {
        this.dcList.push({
          lump_no: "",
          design_no: "",
          color: "",
          hsn: "",
          width: "",
          qty: 0,
          wo_no: "",
          grn_id : 0,
          grn_det_id : 0,
          stock_type : ''
        });

        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();
      } else if (barcode == "" && nxtInd == len) {
        const a = nxtInd - 1;
        $("#" + this.page_id + "barcode" + "-" + a).focus();
      } else {
        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();

        return false;
      }
    }

    //   nxtInd = this.designList.length - 1;
    else if (fld == "item_name") {
      const nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 200);
    }
  }

  isRowEmpty(ind) {
    const data = this.dcList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    const that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change"
    }).then(
      function() {
        if (that.dcList.length > 1) {
          that.dcList.splice(ind, 1);

          if (that.dcdata.type == "Work Order") {
            that.calctot();
          } else {
            let totdes = 0;
            const designlist = [];
            for (let i = 0; i < that.dcList.length; i++) {
              const design = that.dcList[i].design_no;
              if (design != "") {
                if (designlist.indexOf(design) == -1) {
                  designlist.push(design);
                  totdes++;
                }
              }
            }
            that.dcdata.total_design = totdes;
          }

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function(dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getRefAuto() {
    this.dcService.getRefAuto({}).then((res: any) => {
      this.dcdata.ref_no = res;
    });
  }

  getAuto() {
    this.dcService.getdcAuto({}).then((res: any) => {
      this.dcdata.dc_no = res;
    });
  }


 

  onClickCode(party_code) {
    const partyCodeList = _.filter(this.codeList, { code: party_code });
    this.dcdata.party_id = partyCodeList[0]["party_id"];
    this.dcdata.party_name = partyCodeList[0]["party_name"];
  }

  onclickunit(dept) {
    const partyCodeList = _.filter(this.unitList, { dept_name: dept });
    this.dcdata.dept_id = partyCodeList[0]["dept_id"];
  }

  getbarcodeListForSample() {
    this.dcService.getbarcodeListForSample({}).then((res: any) => {
      this.barcodeList = res.data;
      for (let i = 0; i < this.barcodeList.length; i++) {
        this.barcodeList[i].barcode = this.barcodeList[i].barcode
          .toString()
          .padStart(6, "0");
      }
    });
  }

  getdcdesignList(id) {
    const params = {
      dc_id: id
    };
    this.dcService.dcDesignList(params).then((res: any) => {
      this.dcList = res.data;
      for (let i = 0; i < this.dcList.length; i++) {
        this.dcList[i].lump_no = this.dcList[i].lump_no
          .toString()
          .padStart(6, "0");
      }
    });
  }
  //Barcode Reader

  onChangeCode(barcode, design, ind) {
    if (barcode.length == 6) {
      const data = _.filter(this.barcodeList, { barcode: barcode });
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.lump_no == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.width = "";
        design.qty = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists"
        });
      }

      else {
        let barcodeExists = this.WorkOrderBarcode(barcode);

        if(!barcodeExists){
          swal("This Barcode doesn't belongs to selected Wo.No");
          return;
        }
    
          design.design_no =
          data[0]["stock_type"] == "GRN"
            ? data[0]["design_no"]
            : data[0]["fab_design"];
        design.id = data[0]["id"];
        design.color =
          data[0]["stock_type"] == "GRN" ? data[0]["shade"] : data[0]["color"];
        design.width =
          data[0]["stock_type"] == "GRN"
            ? data[0]["width"]
            : data[0]["jgrn_width"];
        design.qty = data[0]["avl_mtrs"] > 0 ? data[0]["avl_mtrs"] : 0;
        design.stock_type = data[0].stock_type;
        design.grn_id = data[0].grn_id;
        design.grn_det_id = data[0].grn_det_id;
        design.grn_type = data[0].grn_type;


        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        this.dcdata.total_design = totdes;

        //get workorder number
      
        
      }
    }
  }
  checkQty(qty, row, ind) {
    this.barcodeList;
    let that = this;
    this.barcodeList.forEach(function(element) {
      if (row.lump_no == element.barcode) {
        if (qty > element.mtrs) {
          that.barcodeList[0].qty = 0;
          that.dcList[ind].qty = 0;
        }
      }
    });
    if (qty > row.qty) {
      this.dcList[ind].qty = 0;
    }
  }
  onSelectItem($event, design, ind) {
    // debugger;
    const barcode = $event.item.barcode;
    if (barcode.length == 6) {
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.lump_no == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.width = "";
        design.qty = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists"
        });
      }

     else {

        let barcodeExists = this.WorkOrderBarcode(barcode);

        if(!barcodeExists){
          swal("This Barcode doesn't belongs to selected Wo.No");
          return;
        }
      

        design.design_no =
          $event.item.stock_type == "GRN"
            ? $event.item.design_no
            : $event.item.fab_design;
        design.id = $event.item.id;
        design.color =
          $event.item.stock_type == "GRN"
            ? $event.item.shade
            : $event.item.color;
        design.width =
          $event.item.stock_type == "GRN"
            ? $event.item.width
            : $event.item.jgrn_width;
        design.qty = $event.item.avl_mtrs > 0 ? $event.item.avl_mtrs : 0;
        design.stock_type = $event.item.stock_type;
        design.grn_id = $event.item.grn_id;
        design.grn_det_id = $event.item.grn_det_id;
        design.grn_type = $event.item.grn_type;


        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        this.dcdata.total_design = totdes;

        //get workorder number
     
      }
    }
  }
  WorkOrderBarcode(barcode){
    var workOrderBarcodeExists : boolean;

    if(this.dcdata.type == "Work Order" && this.mode == 'WorkOrderDc'){
      debugger;
      const zeroPad = (num, places) => String(num).padStart(places, '0');
      workOrderBarcodeExists = false;
      

     this.workOrderBarcodeList.forEach(el => {
       let workOrderBarcode = zeroPad(el.barcode,6);
      if(workOrderBarcode == barcode){
        workOrderBarcodeExists = true;
      }
     });
    }else{
      workOrderBarcodeExists = true;
    }

    return workOrderBarcodeExists;
  }
  oncheckemptyrow() {
    const design = this.dcList;
    const desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].lump_no != "") {
        desList.push(design[i]);
      }
    }
    this.dcList = desList;
    this.addUpdateSampleToBit();
  }
  calctot() {
    let totmtr = 0;
    for (let i = 0; i < this.dcList.length; i++) {
      const dcdata = this.dcList[i];
      totmtr += dcdata.qty;
    }

    this.dcdata.total_mtr = totmtr;
  }

  getSampleToBitConvertedList(stockId): void {
    let that = this;

    let params = {};
    params["stockId"] = JSON.stringify(stockId);
    that.loadingIndicator = true;
    
    that.isLoadMask = that.dcService
      .getSampleToBitConvertedList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.dcdata = res.data;
        that.loadeditJGRNPrintList(that.dcdata);
      });
  }
  

 

  addUpdateSampleToBit(): void {
    const params: any = Object.assign({}, this.dcdata);
    params["tabevent"] = undefined;
    params["dcList"] = JSON.stringify(this.dcList);
    //  params['workorder'] = this.dcdata.workorder || '';
    params["mode"] = this.mode;
    params["from"] = this.dcdata.From || "";
    params["to"] = this.dcdata.to || "";

    params["dc_date"] = this.datePipe.transform(
      params["dc_date"],
      "yyyy-MM-dd"
    );
    const that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to convert this to bit?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change"
    }).then(function() {
      that.isLoading = true;
      that.dcService
        .addUpdateSampleToBit(params)
        .then(function(res: any) {
          that.isLoading = false;
          // if (that.saveEvent) {
          //   that.saveEvent.emit();
          // }

          if (res.response.success) {
            that.printRes = res.response;
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message
              });

              swal({
                title: "Click YES for Sticker Print?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes!",
                cancelButtonText: "No",
              }).then(() => {
                that.getSampleToBitConvertedList(that.printRes.stockId);
              }).catch(() => {
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                  that.saveEvent.emit();
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              });
            

            // that.print(res);
          } else {
            swal("ERROR", res.message, "error");
          }

         
        })
        .catch(function(error: any) {
          that.isLoading = false;
          const res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  loadeditJGRNPrintList(rows) {
    let that = this;
      var row  = rows;
      // that.calcTotal();
      // that.calcQty();
      if(row[0].jgrnType == 'BIT'){
        swal({
          title: "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          let data = [];
          data.push(Object.assign({}, row));
          that.clickPrint(row[0], row);
        });
      }
  }

  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn.jgrnprint(params).then(function (res: any) {
      if (that.mode == "Add") {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
        that.saveEvent.emit();
      } else {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sampleToBitConvertGrn/addEditsampleToBitConvertGrn.ts